import { Select as SelectPrimitive } from '@base-ui/react/select';

import CheckIcon from '@/assets/svg/bx-check.svg?react';
import { cn } from '@/lib/utils';

import { pickerOptionSizeClasses, pickerTriggerIconSizeClasses } from '../pickerPrimitiveStyles';
import { useSelectContext } from './SelectContext';

export type SelectItemProps = SelectPrimitive.Item.Props;

const SelectItem = ({ className, children, ...props }: SelectItemProps) => {
  const { size } = useSelectContext();

  return (
    <SelectPrimitive.Item
      data-slot="select-item"
      className={cn(
        'group relative flex w-full cursor-pointer items-center gap-1.5 rounded-md outline-hidden select-none',
        'aria-selected:font-semibold',
        'pr-8 pl-2.25',
        'focus:not-data-disabled:bg-green-400',
        '*:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2',
        'data-disabled:cursor-not-allowed data-disabled:bg-gray-100 data-disabled:text-gray-500',
        '[&_svg]:pointer-events-none [&_svg]:shrink-0',
        pickerOptionSizeClasses[size],
        pickerTriggerIconSizeClasses[size],
        className,
      )}
      {...props}
    >
      <SelectPrimitive.ItemText className="flex flex-1 shrink-0 gap-2 group-data-disabled:pointer-events-none">
        {children}
      </SelectPrimitive.ItemText>
      <SelectPrimitive.ItemIndicator
        render={
          <span className="pointer-events-none absolute right-1 flex items-center justify-center">
            <CheckIcon className="pointer-events-none" />
          </span>
        }
      />
    </SelectPrimitive.Item>
  );
};

export default SelectItem;
